import { render } from "./productSeoBrand.vue?vue&type=template&id=fd551a38"
import script from "./productSeoBrand.vue?vue&type=script&lang=js"
export * from "./productSeoBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__